// extracted by mini-css-extract-plugin
module.exports = {"List":"BuildingSelectPage_List__Cb9pK"};